import { createAction } from 'redux-actions';
import initialState from './initialState';
import formatActionTypeNames from '../helpers/formatActionTypeNames';

import { actions as authActions } from './auth.reducer';

export const actions = formatActionTypeNames(
	{
		setState: 'SET_STATE',

		altTag: 'ALT_TAG',
		associations: 'ASSOCIATIONS',
		// calendar: 'CALENDAR',
		clients: 'CLIENTS',
		componentDetails: 'COMPONENT_DETAILS',
		construxHomeSlider: 'CONSTRUX_HOME_SLIDER',
		contactPersons: 'CONTACT_PERSONS',
		faq: 'FAQ',
		forms: 'FORMS',
		location: 'LOCATION',
		page: 'PAGE',
		pageComponent: 'PAGE_COMPONENT',
		pageComponents: 'PAGE_COMPONENTS',
		product: 'PRODUCT',
		productCategory: 'PRODUCT_CATEGORY',
		removeClient: 'REMOVE_CLIENT',
		sectionDetails: 'SECTION_DETAILS',
		service: 'SERVICE',
		serviceCategory: 'SERVICE_CATEGORY',
		setAssociations: 'SET_ASSOCIATIONS',
		setCalendar: 'SET_CALENDAR',
		setClients: 'SET_CLIENTS',
		setConstruxHomeSlider: 'SET_CONSTRUX_HOME_SLIDER',
		setContactPersons: 'SET_CONTACT_PERSONS',
		setFaq: 'SET_FAQ',
		setForms: 'SET_FORMS',
		setLocation: 'SET_LOCATION',
		setPage: 'SET_PAGE',
		setProduct: 'SET_PRODUCT',
		setService: 'SET_SERVICE',
		setTestimonials: 'SET_TESTIMONIALS',
		testimonials: 'TESTIMONIALS',
	},
	'PPC'
);

export const ppcActions = {
	setState: createAction(actions.setState),

	altTag: createAction(actions.altTag),
	associations: createAction(actions.associations),
	// calendar: createAction(actions.calendar),
	clients: createAction(actions.clients),
	componentDetails: createAction(actions.componentDetails),
	construxHomeSlider: createAction(actions.construxHomeSlider),
	contactPersons: createAction(actions.contactPersons),
	faq: createAction(actions.faq),
	forms: createAction(actions.forms),
	location: createAction(actions.location),
	page: createAction(actions.page),
	pageComponent: createAction(actions.pageComponent),
	pageComponents: createAction(actions.pageComponents),
	product: createAction(actions.product),
	productCategory: createAction(actions.productCategory),
	sectionDetails: createAction(actions.sectionDetails),
	service: createAction(actions.service),
	serviceCategory: createAction(actions.serviceCategory),
	setAssociations: createAction(actions.setAssociations),
	setCalendar: createAction(actions.setCalendar),
	setClients: createAction(actions.setClients),
	setConstruxHomeSlider: createAction(actions.setConstruxHomeSlider),
	setContactPersons: createAction(actions.setContactPersons),
	setFaq: createAction(actions.setFaq),
	setForms: createAction(actions.setForms),
	setLocation: createAction(actions.setLocation),
	setPage: createAction(actions.setPage),
	setProduct: createAction(actions.setProduct),
	setService: createAction(actions.setService),
	setTestimonials: createAction(actions.setTestimonials),
	testimonials: createAction(actions.testimonials),
};

export default (state = initialState.ppc, action) => {
	const { payload } = action;

	switch (action.type) {
		case actions.setState:
			return {
				...state,
				...payload,
			};

		case actions.setPage:
			return {
				...state,
				page: {
					details: payload.details ?
						{ ...state.page.details, ...payload.details } :
						{ ...state.page.details },
					index: payload.index ?
						{ ...state.page.index, ...payload.index } :
						{ ...state.page.index },
				},
			};

		case actions.setLocation:
			return {
				...state,
				location: {
					details: payload.details ?
						{ ...state.location.details, ...payload.details } :
						{ ...state.location.details },
					index: payload.index ?
						{ ...state.location.index, ...payload.index } :
						{ ...state.location.index },
				},
			};

		case actions.setFaq:
			return {
				...state,
				faq: {
					...state.faq,
					...payload,
				},
			};

		case actions.setForms:
			return {
				...state,
				forms: {
					...state.forms,
					...payload,
				},
			};

		case actions.setContactPersons:
			return {
				...state,
				contacts: {
					...state.contacts,
					...payload,
				},
			};

		case actions.setProduct:
			return {
				...state,
				product: {
					category: payload.category ?
						{ ...state.product.category, ...payload.category } :
						{ ...state.product.category },
					details: payload.details ?
						{ ...state.product.details, ...payload.details } :
						{ ...state.product.details },
					index: payload.index ?
						{ ...state.product.index, ...payload.index } :
						{ ...state.product.index },
				},
			};

		case actions.setService:
			return {
				...state,
				service: {
					category: payload.category ?
						{ ...state.service.category, ...payload.category } :
						{ ...state.service.category },
					details: payload.details ?
						{ ...state.service.details, ...payload.details } :
						{ ...state.service.details },
					index: payload.index ?
						{ ...state.service.index, ...payload.index } :
						{ ...state.service.index },
				},
			};

		case actions.setAssociations:
			return {
				...state,
				...payload,
			};

		case actions.setClients:
			return {
				...state,
				...payload,
			};

		case actions.setCalendar:
			return {
				...state,
				calendarEvents: {
					...state.calendarEvents,
					...payload,
				},
			};

		case actions.setTestimonials:
			return {
				...state,
				...payload,
			};

		case actions.setConstruxHomeSlider:
			return {
				...state,
				construxHomeSlider: payload,
			};

		case authActions.logoutComplete:
			return initialState.ppc;

		default:
			return state;
	}
};
